export default {
  title: 'Kurv',
};
